let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("fCG34")).then(() => parcelRequire('7XZu2'));